var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./slick.tree.css";
export var IndentFormatter = function (row, cell, value, columnDef, dataContext, grid) {
    var result = "";
    var hierachy = grid._hierachy;
    if (hierachy != null) {
        var options = hierachy.getOptions();
        var level = hierachy.getLevel(dataContext);
        if (level > 0) {
            result += "<span class='jsl-indent' style='min-width:" + (level * hierachy.getOptions().indentInRem) + "rem;'></span>";
        }
        if (options.enableCollapsing) {
            var hasChildren = hierachy.hasChildren(dataContext);
            if (hasChildren) {
                if (dataContext[options.collapsedStateField]) {
                    result += "<span class='jsl-toggle'>" + options.expandIconHTML + "</span>";
                }
                else {
                    result += "<span class='jsl-toggle'>" + options.collapseIconHTML + "</span>";
                }
            }
            else {
                result += "<span class='jsl-toggle-spacer'></span>";
            }
        }
    }
    if (value != null) {
        result += (value + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    return result;
};
var GridTree = /** @class */ (function () {
    function GridTree(grid, o) {
        this.grid = grid;
        this.options = __assign({
            enableCollapsing: true,
            indentInRem: 1,
            hiddenStateField: "_hidden_by_h",
            collapsedStateField: "_callapsed",
            expandIconHTML: "▶",
            collapseIconHTML: "▼" // "˅"
        }, o);
        this.primaryKey = this.grid.getOptions().primaryKey;
        grid._hierachy = this;
        grid.refresh();
        this.initEvents();
    }
    GridTree.prototype.getOptions = function () {
        return this.options;
    };
    GridTree.prototype.getLevel = function (item) {
        var level = 0;
        var parent = this.getParent(item);
        while (parent != null) {
            parent = this.getParent(parent);
            level++;
        }
        return level;
    };
    GridTree.prototype.getParent = function (item) {
        return this.grid.dataView.getItemById(item[this.options.parentColumn]);
    };
    GridTree.prototype.hasChildren = function (item) {
        return this.rowHasChildren(this.grid.dataView.getIdxByItem(item));
    };
    GridTree.prototype.getDirectChildren = function (item) {
        var id = item[this.primaryKey];
        var result = [];
        var data = this.grid.getData();
        for (var i = 0; i < data.length; i++) {
            var pid = data[i][this.options.parentColumn];
            if (pid === id) {
                result.push(data[i]);
            }
        }
        return result;
    };
    GridTree.prototype.getAllChildren = function (item) {
        var parentid = item[this.primaryKey];
        var result = [];
        var data = this.grid.getData();
        for (var i = 0; i < data.length; i++) {
            if (data[i][this.options.parentColumn] === parentid) {
                result.push(data[i]);
                result.push.apply(result, this.getAllChildren(data[i]));
            }
        }
        return result;
    };
    GridTree.prototype.rowHasChildren = function (row) {
        var data = this.grid.getData();
        if (data.length > row + 1) {
            return data[row + 1][this.options.parentColumn] === data[row][this.primaryKey];
        }
        return false;
    };
    GridTree.prototype.toggleExpand = function (item) {
        if (item[this.options.collapsedStateField]) {
            this.expand(item);
        }
        else {
            this.collapse(item);
        }
    };
    GridTree.prototype.expand = function (item) {
        item[this.options.collapsedStateField] = false;
        var data = this.grid.getData();
        var i = this.grid.dataView.getIdxByItem(item);
        while (i < data.length) {
            data[i][this.options.hiddenStateField] = false;
            if (this.rowHasChildren(i)) {
                if (data[i][this.options.collapsedStateField]) {
                    //skip children
                    i += this.getAllChildren(data[i]).length;
                }
            }
            i++;
        }
        this.grid.refreshData();
    };
    GridTree.prototype.indent = function (rows) {
        var realRows = this.filterChildren(rows);
        var data = this.grid.getData();
        //get indexes of rows
        var indexes = [];
        for (var i = 0; i < realRows.length; i++) {
            indexes.push(this.grid.dataView.getIdxByItem(realRows[i]));
        }
        //sort indexes
        indexes.sort(function (a, b) { return a > b ? 1 : (a < b ? -1 : 0); });
        //change parents to indent rows
        for (var i = 0; i < indexes.length; i++) {
            var rowIdx = indexes[i];
            var parentID = data[rowIdx][this.options.parentColumn];
            for (var tmp = rowIdx - 1; tmp >= 0; tmp--) {
                if (data[tmp][this.options.parentColumn] === parentID) {
                    data[rowIdx][this.options.parentColumn] = data[tmp][this.primaryKey];
                    break;
                }
            }
        }
        this.grid.refreshData();
    };
    GridTree.prototype.outdent = function (rows) {
        var rows2 = this.filterChildren(rows);
        var data = this.grid.getData();
        for (var i = 0; i < rows2.length; i++) {
            var row = rows2[i];
            var oldparent = row[this.options.parentColumn];
            if (oldparent) {
                var newparent = data[this.grid.dataView.getIdxById(oldparent)][this.options.parentColumn];
                row[this.options.parentColumn] = newparent;
                //make all subsequent items with same ParentID have current row as new parentid
                var idx = this.grid.dataView.getIdxById(row[this.primaryKey]);
                while (++idx < data.length) {
                    if (data[idx][this.options.parentColumn] === oldparent) {
                        data[idx][this.options.parentColumn] = row[this.primaryKey];
                    }
                    //TODO: optimize -> break sooner
                }
            }
        }
        this.grid.refreshData();
    };
    GridTree.prototype.filterChildren = function (rows) {
        var result = [];
        var dict = {};
        for (var i = 0; i < rows.length; i++) {
            dict[rows[i][this.primaryKey]] = true;
        }
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            var parentid = row[this.options.parentColumn];
            if (!parentid || !dict[parentid]) {
                result.push(row);
            }
        }
        return result;
    };
    GridTree.prototype.collapse = function (item) {
        item[this.options.collapsedStateField] = true;
        var children = this.getAllChildren(item);
        for (var i = 0; i < children.length; i++) {
            children[i][this.options.hiddenStateField] = true;
        }
        this.grid.refreshData();
    };
    GridTree.prototype.initEvents = function () {
        var _this = this;
        // collapse / expand click events
        if (this.options.enableCollapsing) {
            this.grid.onClick.subscribe(function (e, args) {
                if (e.target.classList.contains("jsl-toggle")) {
                    e.stopImmediatePropagation();
                    _this.toggleExpand(_this.grid.dataView.getItem(args.row));
                }
            });
        }
        // filters
        var hiddenFilter = {
            field: this.options.hiddenStateField,
            match: function (itm, field) {
                return !itm[_this.options.hiddenStateField];
            }
        };
        this.grid.addFilter(hiddenFilter);
    };
    return GridTree;
}());
export { GridTree };
